module.exports = __webpack_public_path__ + "img/download-icon-audio-select.dff3bcd3.svg";